import logo from './rw-logo.png';
import { Button, Nav, Navbar, Container, Row, Col, Form, OverlayTrigger, Tooltip, Popover, Overlay, Modal, ListGroup, Offcanvas } from 'react-bootstrap';
import { NavObjectType } from "./navigationTypes";
import { useState, useRef, useContext, useEffect } from 'react';
import './mainbar.css';
import { useAppSelector } from "../redux/hooks";
import { lddGlobalSessionInfo } from '../Components/navigationTypes'
import { NavigationContext } from '../Context/NavigationContext';
import { Notifications } from './Notifications';
import ClientConnectFirmSettings from './Settings/ClientConnectFirmSettings';

const OpenMainPage: NavObjectType = { component: "filelist" };

const GetAccountName = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return <>loading...</>;
    }
    return sessionInfo.firm.account;
}
const GetFullName = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return <>loading...</>;
    }
    return sessionInfo.user.fullname;
}

const GetInitials = (sessionInfo: lddGlobalSessionInfo) => {
    if (sessionInfo === undefined) {
        return "...";
    }
    return sessionInfo.user.initials;
}

function LegacyView(sessionInfo: lddGlobalSessionInfo) {
    var loc = window.location.pathname;
    loc = loc.substring(1);
    var newLoc = loc.substring(0, loc.indexOf("/") + 1)
    loc = loc.substring(loc.indexOf("/") + 1);
    newLoc += loc.substring(0, loc.indexOf("/"))
    var url = `${window.location.origin}/${newLoc}/menu.asp?SessionID=${sessionInfo.sid}`;
    var storageObj = window.localStorage;
    storageObj.setItem("InterfaceView", "0");
    window.location.href = url;
}

async function launchLDDnxt(url: string, sid: string, SessionInfo: lddGlobalSessionInfo) {
    if (url.indexOf("book-training-rw") !== -1) {
        url += "#book-training-rw" + (process.env.REACT_APP_APPCODE).toLowerCase();
    }
    url = `${url}&first_name=${SessionInfo.user.firstname}&last_name=${SessionInfo.user.lastname}&email=${SessionInfo.user.email}&a1=${SessionInfo.firm.name}&phone=${SessionInfo.user.phone}&acc_name=${SessionInfo.firm.account}&acc_id=${SessionInfo.firm.id}&province=${process.env.REACT_APP_APPCODE}`;
    window.open(url, "_blank");
}

export const OpenReports: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formxml': 'SingleReport', "onload": "report_init", "src": "getprofile.asp?pname=ReportProfile" } };
export const OpenUserSettings: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserCredentials" } };
const OpenFirmProfile: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "lawyerProfileSection" } };
const OpenFirmProfileStmt: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "AccountDefault_SectionTable" } };
const OpenFirmProfileTrust: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "TrustDefault_SectionTable" } };
const OpenFirmProfileFinancial: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "FinancialDefaults_SectionTable" } };
const OpenFirmProfileDocs: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "other_SectionTable" } };
const OpenFirmProfileAccount: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "TrustAccount_SectionTable" } };
const OpenFirmProfile3rdParty: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formasp": "EditUserProfile", "goToSection": "3rdParty_SectionTable" } };
const OpenUserFields: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { "formxml": "UserDefinedFields", "src": "getprofile.asp?pname=UserDefinedFields" } };
const OpenCalendarUserProfile: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formxml': 'CalendarUserProfile', "onload": "cal_init", "src": "getCalendarProfile.asp?pname=CalendarProfile" } };
const OpenFileTemplates: NavObjectType = { component: "main", url: "DisplayList.asp", popup: false, params: { 'ListName': 'AllFileTemplates' } };
const OpenFileListColumns: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formxml': 'MainListDefine', 'src': 'getprofile.asp?pname=MainListDefine' } };
const OpenDocMasters: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formasp': 'ListDocument' } };
const OpenDocTemplates: NavObjectType = { component: "main", url: "DisplayList.asp", popup: false, params: { 'ListName': 'AllTemplateTypes' } };
const OpenMunicipalitiesAll: NavObjectType = { component: "main", url: "DisplayList.asp", popup: false, params: { 'ListName': 'municAll' } };
const OpenMunicipalitiesCustomized: NavObjectType = { component: "main", url: "tableBrowser.asp", popup: false, params: { 'name': 'municUser' } };
const OpenBilling: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formasp': 'ShowAccountStatement' } };
const OpenPayments: NavObjectType = { component: "main", url: "lfmaster.asp", popup: false, params: { 'formasp': 'ShowAccountStatement', "adhoc": "1" } };
const OpenBuilderSale: NavObjectType = { component: "main", url: "purFileListBuilder.asp", popup: false };

export function ShowSettingsCanvas(sid: string, SessionInfo: lddGlobalSessionInfo, props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const nav = useContext(NavigationContext);

    const ManageUsers = (sid: string) => {
        useEffect(() => {
            if (!show) {
                setShowManageUsers(false);
            }
        }, [show])

        const [showManageUsers, setShowManageUsers] = useState(false);
        const handleClose = () => setShowManageUsers(false);
        const handleShow = () => setShowManageUsers(true);
        return (<>
            <ListGroup.Item action onClick={handleShow}>Manage Users</ListGroup.Item>
            <Modal show={showManageUsers} onHide={handleClose} className="modal-settings modal-list" backdrop={false}>
                <iframe title="User Management" src={`${window.location.origin}/${process.env.REACT_APP_UM_ENDPOINT}/index.html?SessionID=${sid}`} width="100%" height="100%" />
            </Modal>
        </>)
    }
    return (
        <>
            <Nav.Item className="item">
                <OverlayTrigger placement="bottom" delay={200} overlay={
                    <Tooltip>Settings</Tooltip>
                }>
                    <Nav.Link eventKey="link-4"><i className="fa-duotone fa-gear fa-indicator" onClick={handleShow}></i></Nav.Link>
                </OverlayTrigger>
            </Nav.Item>

            <Offcanvas show={show} onHide={handleClose} placement="end" className="settings-menu" scroll>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Settings</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="settings-tabs">
                    {SidebarTitle("Account", "fa-duotone fa-user")}

                    <ListGroup variant="flush">
                        {SidebarAction("User Settings", OpenUserSettings, sid, nav, handleClose)}
                        {SessionInfo.user.isAdmin && ManageUsers(sid)}
                        {SidebarAction("Custom Fields", OpenUserFields, sid, nav, handleClose)}
                        {SidebarAction("Calendar Preferences", OpenCalendarUserProfile, sid, nav, handleClose)}
                        {SidebarAction("File List Preferences", OpenFileListColumns, sid, nav, handleClose)}
                        {SidebarAction("File Templates", OpenFileTemplates, sid, nav, handleClose)}
                    </ListGroup>

                    {SidebarTitle("Firm Settings", "fa-duotone fa-city")}

                    <ListGroup variant="flush">
                        {SidebarAction("Firm Information", OpenFirmProfile, sid, nav, handleClose)}

                        {SessionInfo.appCode === "RPWBC" && SidebarAction("Financial Defaults", OpenFirmProfileFinancial, sid, nav, handleClose)}
                        {SidebarAction("Statement of Accounts", OpenFirmProfileStmt, sid, nav, handleClose)}
                        {SessionInfo.appCode !== "RPWBC" && SidebarAction("Trust Statement", OpenFirmProfileTrust, sid, nav, handleClose)}
                        {SidebarAction("Trust Accounts", OpenFirmProfileAccount, sid, nav, handleClose)}
                        {SessionInfo.appCode === "RPW" && SidebarAction("3rd Party Accounts", OpenFirmProfile3rdParty, sid, nav, handleClose)}
                        {/* {(SessionInfo.appCode === "RPW") && <ClientConnectFirmSettings />} */}
                        {<ClientConnectFirmSettings />}

                    </ListGroup>

                    {SidebarTitle("Documents", "fa-duotone fa-file-lines")}

                    <ListGroup variant="flush">
                        {SidebarAction("Masters", OpenDocMasters, sid, nav, handleClose)}
                        {SidebarAction("Templates", OpenDocTemplates, sid, nav, handleClose)}
                        {SidebarAction("Options", OpenFirmProfileDocs, sid, nav, handleClose)}
                    </ListGroup>

                    {(SessionInfo.appCode === "RPWAB" ||
                        SessionInfo.appCode === "RPWMB" ||
                        SessionInfo.appCode === "RPWSK") &&
                        <>

                            {SidebarTitle("Builder", "fa-duotone fa-apartment")}

                            <ListGroup>
                                {SidebarAction("Manage Builder Sale Files", OpenBuilderSale, sid, nav, handleClose)}
                            </ListGroup>
                        </>
                    }

                    {SidebarTitle("Databases", "fa-duotone fa-list")}

                    <ListGroup variant="flush">
                        {(SessionInfo.appCode === "RPW" || SessionInfo.appCode === "RPWAB") ?
                            SidebarAction("Municipalities", OpenMunicipalitiesAll, sid, nav, handleClose)
                            : SidebarAction("Municipalities", OpenMunicipalitiesCustomized, sid, nav, handleClose)
                        }
                    </ListGroup>

                    {SidebarTitle("Billing & Reports", "fa-duotone fa-file-invoice")}

                    <ListGroup variant="flush">
                        {SidebarAction("Billing Statements", OpenBilling, sid, nav, handleClose)}
                        {SidebarAction("Upcoming Payments", OpenPayments, sid, nav, handleClose)}
                        {SidebarAction("Reports", OpenReports, sid, nav, handleClose)}
                    </ListGroup>

                    {SidebarTitle("Help & Support", "fa-duotone fa-life-ring")}

                    <ListGroup variant="flush">
                        <ListGroup.Item action onClick={() => window.open("https://lawyerdonedeal.zohodesk.com/portal/en/kb/ldd")}>Knowledge Base</ListGroup.Item>
                        <ListGroup.Item action onClick={() => launchLDDnxt('https://www.ldd.ca/book-training-rw', sid, SessionInfo)}>Book Training</ListGroup.Item>
                    </ListGroup>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}
function SidebarTitle(title: string, icon: string) {
    return (
        <h4><i className={icon}></i>{title}</h4>
    )
}
function SidebarAction(title: string, click: NavObjectType, sid: string, nav: Function, closeSidebar: Function) {
    return (
        <ListGroup.Item action onClick={() => { nav(click); closeSidebar() }}>{title}</ListGroup.Item>
    )
}

function toggleDarkTheme(e) {
    var checked = e.target.checked;
    var val = (checked) ? 1 : 0;
    setCookie('darkMode', val, 365);
    framesChangeClass("dark", checked);
}

export function setTheme() {
    framesChangeClass("dark", isDarkTheme())
}

function framesChangeClass(className: string, add: boolean) {
    if (add) {
        document.body.classList.add(className);
        document.documentElement.setAttribute('data-bs-theme', 'dark')
    } else {
        document.body.classList.remove(className);
        document.documentElement.setAttribute('data-bs-theme', 'light')
    }
    var allFrames = document.getElementsByTagName("iframe");
    for (var i = 0; i < allFrames.length; i++) {
        if (allFrames[i].src.toLowerCase().indexOf(`${window.location.origin}/dr/`) === -1) {
            var tmp = allFrames[i].contentDocument.body;
            if (add) {
                tmp.classList.add(className);
                document.documentElement.setAttribute('data-bs-theme', 'dark')
            } else {
                tmp.classList.remove(className);
                document.documentElement.setAttribute('data-bs-theme', 'light')
            }
        }
    }
}

function isDarkTheme() {
    var val = getCookie("darkMode") === "1";
    if (val && !document.body.classList.contains('dark')) {
        document.body.classList.add("dark");
        setTheme();
    }
    return val;
}

function logout() {
    window.location.href = 'logout.asp';
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const OpenInbox: NavObjectType = {
    component: "main",
    url: "lfpopup.asp",
    popup: true,
    popupStyle: "xlarge",
    isModal: true,
    params: { "compat": "1", 'NoHeader': '1', 'ReactInvisible': '1', 'diagData': '1', 'formasp': 'inboxFrame', 'openFromMain': "1" },
    redirect: true,
    callback: (retval: string) => {
        var retvalArr = retval.split('-');
        if (retvalArr.length && retvalArr[0] === 'url') {
            //window.location.href = arr[1];
            console.log(retvalArr[1]);
            const urlReg = /([\w.]+)\?/;
            const paramsRegs = {
                formasp: /formasp=(\w+)&?/,
                src: /src=([\w.]+)&?/,
                tb: /tb=(\w+)&?/,
                id: /id=(\w+)&?/,
                onload: /onload=([\w\d\s(),"]+)&?/,
            };
            const redirectNav: NavObjectType = {
                component: 'main',
                params: {},
                controller: null
            };
            const urlArr = retval.match(urlReg);
            if (urlArr && urlArr[1]) {
                redirectNav.url = urlArr[1];
            }
            Object.keys(paramsRegs).forEach(r => {
                const regArr = retval.match(paramsRegs[r]);
                if (regArr && regArr[1]) {
                    redirectNav.params[r] = regArr[1];
                }
            });
            if (redirectNav.params.formasp && redirectNav.params.formasp === "purfileedit") {
                redirectNav.params['ReactDocument'] = '-1';
                redirectNav.controller = {
                    tabName: "Basic",
                    tabNumber: 0,
                    refresh: true,
                };
            }
            return redirectNav;
        }
        return null;
    }
};
const OpenCalendar: NavObjectType = { component: "main", url: "calendar.asp", popup: true, popupStyle: "xlarge", isModal: true, params: { "compat": "1", "viewTab": "3", 'NoHeader': '1' } };


const TopBar = (props) => {
    const nav = useContext(NavigationContext);
    const sid: string = useAppSelector((state) => state.SessionID);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const profileRef = useRef(null);

    const [showAccount, setShowAccount] = useState(false);
    const [targetAccount, setTargetAccount] = useState(null);
    const refAccount = useRef(null);
    const handleAccountClick = (event) => {
        setShowAccount(!showAccount);
        setTargetAccount(event.target);
    }

    let appcode = "";
    switch (sessionInfo.appCode) {
        case "RPW": appcode = "ON"; break;
        case "RPWAB": appcode = "AB"; break;
        case "RPWSK": appcode = "SK"; break;
        case "RPWMB": appcode = "MB"; break;
        case "RPWNS": appcode = "NS"; break;
        case "RPWBC": appcode = "BC"; break;
    }

    return (
        <>
            <Navbar className="nav-global">
                <OverlayTrigger placement="bottom" delay={200} overlay={
                    <Tooltip>Home</Tooltip>
                }>
                    <span className="logo">
                        <img src={logo} alt="RW" onClick={() => nav(OpenMainPage)} />
                        <p className="province">{appcode}</p>
                    </span>
                </OverlayTrigger>

                <Navbar.Toggle />

                <div className="dialog-title" />

                <Navbar.Collapse className="justify-content-end">
                    <Nav.Item className="item" onClick={() => nav(OpenMainPage)}>
                        <OverlayTrigger placement="bottom" delay={200} overlay={
                            <Tooltip>Home</Tooltip>
                        }>
                            <Nav.Link eventKey="link-1"><i className="fa-duotone fa-house fa-action"></i></Nav.Link>
                        </OverlayTrigger>
                    </Nav.Item>

                    <Nav.Item className="item" onClick={() => nav(OpenCalendar)}>
                        <OverlayTrigger placement="bottom" delay={200} overlay={
                            <Tooltip>Calendar</Tooltip>
                        }>
                            <Nav.Link eventKey="link-1"><i className="fa-duotone fa-calendar fa-indicator"></i></Nav.Link>
                        </OverlayTrigger>
                    </Nav.Item>

                    <Nav.Item className="item" onClick={() => nav(OpenInbox)}>
                        <OverlayTrigger placement="bottom" delay={200} overlay={
                            <Tooltip>Inbox</Tooltip>
                        }>
                            <Nav.Link eventKey="link-2"><i className="fa-duotone fa-inbox fa-indicator"></i></Nav.Link>
                        </OverlayTrigger>
                    </Nav.Item>

                    <Notifications />
                    {ShowSettingsCanvas(sid, sessionInfo, props)}

                    <Overlay
                        show={showAccount}
                        placement="bottom-end"
                        rootClose={true}
                        onHide={() => setShowAccount(false)}
                        target={targetAccount}
                    >
                        <Popover bsPrefix="nav-popover" ref={profileRef}>
                            <Popover.Body bsPrefix="nav-popover-body">
                                <Container fluid className="gx-0">
                                    <Row className="mb-3">
                                        <Col className='col-2 align-top'>
                                            <span className="avatar">
                                                <span id="intitials">{GetInitials(sessionInfo)}</span>
                                            </span>
                                        </Col>
                                        <Col className='col-10'>
                                            <b>{GetFullName(sessionInfo)}</b>
                                            <Form.Label>{GetAccountName(sessionInfo)}</Form.Label>
                                            <Button variant="outline-primary" onClick={logout}>Log Out</Button>
                                            <Button variant="text" style={{ display: "none" }}>Switch Firm</Button>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className='col-12'>
                                            <h3>User Preferences</h3>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className='col-12'>
                                            <div className="ldd_pointer" style={{ paddingBottom: '5px' }} onClick={() => nav(OpenUserSettings)}>My Profile</div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className='col-8'>
                                            <span>Dark Theme</span>
                                        </Col>
                                        <Col className='col-4 align-right'>
                                            {/*<BootstrapSwitchButton checked={isDarkTheme()} onChange={(checked:boolean) => {toggleDarkTheme(checked)}} onstyle="outline-success" offstyle="outline-danger" size="xs"/>*/}

                                            <Form.Check
                                                type="switch"
                                                id="dark-mode-switch"
                                                aria-label="Check this switch"
                                                onChange={toggleDarkTheme}
                                                defaultChecked={isDarkTheme()}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='col-12'>
                                            <div className="ldd_pointer" style={{ paddingTop: '5px' }} onClick={() => LegacyView(sessionInfo)}>Go to Legacy View</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </Popover.Body>
                        </Popover>
                    </Overlay>
                    <OverlayTrigger placement="bottom" delay={200} overlay={
                        <Tooltip>Account</Tooltip>
                    }>
                        <Nav.Item className="item avatar" style={{ marginLeft: '10px' }} ref={refAccount} onClick={handleAccountClick}>
                            <span id="intitials">{GetInitials(sessionInfo)}</span>
                        </Nav.Item>
                    </OverlayTrigger>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
}

export default TopBar;
